import React from 'react';
import { Dialog, DialogContent } from "@mui/material";

const CategoryRejectPopup = ({ open, onClose, handleAdminResponse, selectAlertId }) => {
  return (
     <Dialog
          open={open}
          onClose={onClose}
          PaperProps={{
            style: { borderRadius: "20px" },
          }}
        >
          <DialogContent>
            <div className="popup-accept-reject-div">
              <h3 className="delete-img-heading">Are you sure?</h3>
              <p className="delete-img-p">Do you really want to Reject ?</p>
              <div className="delete-btn-div">
                <button
                  onClick={() => {
                    handleAdminResponse(selectAlertId, "reject");
                    onClose();
                  }}
                >
                  Reject
                </button>
                <button onClick={onClose}>Cancel</button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
  )
}

export default CategoryRejectPopup